import './DetailsHostedComp.css';
import React from 'react'
import {Grid,Button} from '@mui/material';
import { FaFilter } from 'react-icons/fa';

const DetailsHostedComp = () => {

    return (
    <div className='DetailsHostedCompMain'>
      <hr style={{marginTop:'7vh',borderColor:'#f2f2f2'}} />
        <div className='hostedCompFirstDiv'>
        <FaFilter style={{width:'5vw',height:'2vw'}} />
        <div className='hostedCompFirstDivSub'>
        <p className='hostedBy'>Hosted by Dorothy</p>
        <p className='hostedJoined'>Joined in October 2015</p>
        </div>
        </div>
        <Grid container>
            <Grid item md={6}>
            <p className='hostedFirstText'>
            <FaFilter  style={{height:18,width:18,marginRight:20}} /> 764 Reviews 
            <FaFilter  style={{height:18,width:18,marginLeft:40,marginRight:20}} /> Identity verified 
            </p>
            <p style={{width:'70%'}}>I was born in 1978 in Izmir.After i have graduated Tourism and Hotel Management, i have worked at various departments 
                in tourism sector keeping to guest relations. At t...
                <p style={{fontWeight:700,textDecoration:'underline',marginTop:0}}>read more</p>
            </p>
            </Grid>

            <Grid item md={6}>
                <p>Languages:English,Turkce</p>
                <p>Response rate: 64%</p>
                <p>Response time: within a day</p>
                <Button
          sx={{
            display: { xs: 'none', md: 'flex' },
            border: '1px solid black',
            minWidth: 90,
            fontWeight:900,
            justifyContent: 'center',
            borderRadius: 2,
            textTransform: 'capitalize',
            py: 1,
            color: 'black',
          }}
        > Contact Host
        </Button>
        <div className='detailsHostedComp'>
            <div style={{width:'5%'}}>
                <FaFilter  style={{height:18,width:18}} />
            </div>
                <div style={{width:'70%'}}>
                 <span style={{marginLeft:0,fontSize:12}}>To protect your payment, never transfer money or communicate outside of the Airbnb website or app.</span>
            </div>

            </div>

            </Grid>
        </Grid>
    </div>
  )
}

export default DetailsHostedComp